import { render } from "./MapaBilboView.vue?vue&type=template&id=8ece2e44&scoped=true"
import script from "./MapaBilboView.vue?vue&type=script&lang=js"
export * from "./MapaBilboView.vue?vue&type=script&lang=js"

import "./MapaBilboView.vue?vue&type=style&index=0&id=8ece2e44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ece2e44"]])

export default __exports__